module.exports = __webpack_public_path__ + "static/media/pdf-simple-icon.4812d334.svg";